'use strict';

exports.__esModule = true;
function checkStatus(response) {
    if (response.ok) {
        return response;
    }

    var error = new Error(response.statusText);
    error.response = response;
    throw error;
}

function convertFetchResponse(resp) {
    var contentType = resp.headers.get('content-type') || '';

    if (contentType.match(/(application|text)\/json/)) {
        return resp.json();
    }
    if (contentType.includes('text/')) {
        return resp.text();
    }

    return resp.blob();
}

function fetchWrapper(url, method) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return fetch(url, Object.assign({
        method: method,
        credentials: 'include'
    }, options)).then(checkStatus).then(function (resp) {
        // status 204 === no content
        if (resp.status !== 204) {
            return convertFetchResponse(resp);
        }
        return resp;
    }).catch(function (e) {
        if (e.response && e.response.text) {
            return convertFetchResponse(e.response).then(function (errorResp) {
                var errObj = {
                    body: errorResp,
                    url: e.response.url,
                    status: e.response.status,
                    statusText: e.response.statusText
                };
                throw errObj;
            });
        }
        throw e;
    });
}

// eslint-disable-next-line import/prefer-default-export
var get = exports.get = function get(url, options) {
    return fetchWrapper(url, 'get', options);
};